<template>
	<v-dialog
		v-model="showDialog"
		persistent
		max-width="500"
	>
		<v-card class="dialog">
			<v-card-title class="success body-2 white--text">
				Add Article From Clipboard?
			</v-card-title>
			<v-progress-linear
				v-show="loading"
				color="primary"
				indeterminate
				class="ma-0"
			/>
			<v-card-text>
				The URL {{ clipboardValue }} was detected.
			</v-card-text>
			<v-divider/>
			<v-card-actions>
				<v-spacer/>
				<v-btn
					:disabled="loading"
					flat
					@click="addArticle(clipboardValue, false)"
				>
					Add
				</v-btn>
				<v-btn
					:disabled="loading"
					flat
					@click="addArticle(clipboardValue, true)"
				>
					Add and Edit
				</v-btn>
				<v-btn
					:disabled="loading"
					flat
					color="error"
					@click="showDialog = false"
				>
					Cancel
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import { Article } from '@/models/Article';
import Validation from '@/mixins/Validation';
import StoreMethods from '@/mixins/StoreMethods';

export default {
	data() {
		return {
			clipboardValue: localStorage.clipboardValue,
			showDialog: false,
			showEdit: false,
			loading: false,
		};
	},
	mixins: [Validation, StoreMethods],
	computed: {
		articles() {
			return this.$store.get('articles');
		},
		currentReport() {
			return this.$store.get('reports/currentReport');
		},
		currentProject() {
			return this.$store.get('projects/currentProject');
		},
		reportPublications() {
			return this.$store.get('reportPublications');
		},
	},
	mounted() {
		window.addEventListener('focus', this.focusEvent);
		this.getClipboardValue();
	},
	beforeDestroy() {
		window.removeEventListener('focus', this.focusEvent);
	},
	methods: {
		focusEvent() {
			this.getClipboardValue();
		},
		getClipboardValue() {
			navigator.clipboard.readText().then((text) => {
				if (this.clipboardValue === text) {
					return;
				}
				this.clipboardValue = text;

				if (this.validateURL(this.clipboardValue) === true) {
					this.showDialog = true;
				}
				else {
					this.showDialog = false;
				}
			}).catch(() => {
				// just do nothing
			});
		},
		addArticle(url, showEdit) {
			this.showEdit = showEdit;
			this.loading = true;
			const model = new Article();
			model.url = url.trim();
			model.reportId = this.currentReport.id;
			model.projectId = this.currentProject.id;
			model.justAdded = true;

			model.save().then(() => {
				this.articles.push(model);
				this.updateReportPublications(model);
				if (this.showEdit) {
					this.editArticle();
				}
				else {
					this.$notify('success', 'Article added.');
				}
			}).catch(() => {
				this.$notify('error', 'Failed to add article.');
			}).finally(() => {
				this.loading = false;
				this.showDialog = false;
				localStorage.clipboardValue = url.trim();
			});
		},
		editArticle() {
			const articles = this.articles;
			const article = articles[articles.length - 1];
			// Push event for add page, emit for quick add
			// this isn't working
			this.$emit('single-edit', article);
		},
		updateReportPublications(article) {
			const publication = this.reportPublications.find(pub => pub.id === article.publicationId);
			if (!publication) {
				this.setStoreReportPublications(this.currentReport.id);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.dialog {
	overflow: hidden;
}
</style>
